import { Component, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IonicPage, LoadingController, NavController, NavParams, ViewController } from 'ionic-angular';
import { Util } from '../../app/util';

/**
 * Generated class for the HrSelezionaMjPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-hr_selezionamj', 
  templateUrl: 'hr_selezionamj.html',
})
export class HrSelezionaMjPage extends Util {
  myInput;
  shouldShowCancel = true;
  mj = [];
  mjaux = [];
  
  constructor(public navCtrl: NavController, public navParams: NavParams, injector: Injector, loading: LoadingController, public translate: TranslateService, public navParam: NavParams, public viewcontroller: ViewController) {
    super(injector, loading);
    // this.squadre = this.navParam.get('squadre');
    this.mj = this.navParam.get('mj');
    this.mj = this.mj.map(m => {
      m.selezionato = true;
      return m;
    })  
    this.mjaux = [...this.mj];
  }
  
  selectAll() {
    this.mj = this.mj.map(m => {
      m.selezionato = true;
      return m;
    })
  }
  
  deselectAll() { 
    this.mj = this.mj.map(m => {
      m.selezionato = false;
      return m;
    })
  }

  sel(id){
    this.mj = this.mj.map(m => {
      if(m.id == id){
        m.selezionato = !m.selezionato;
      }
      return m;
    })
  }
  ionViewDidLoad() {
    // console.log('ionViewDidLoad SelectSquadraPage');


  }

  dismiss() {
    this.viewcontroller.dismiss();
  }
  
  conferma() {
    const mjids = this.mj.filter(m => m.selezionato).map(m => m.id);
    this.viewcontroller.dismiss({mjids});
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    // this.initializeItems();
    this.mj = this.mjaux;
    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.mj = this.mj.filter((item) => {
        return (item.nome.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
  onCancel($event) {

  }

  // cambia(s) {
  //   const alert = this.alertCtrl.create({
  //     title: 'Cambio Squadra',
  //     subTitle: 'Sei sicuro di voler cambiare la squadra da "' + this.squadra_attuale.nome + '" a "' + s.nome + '"?',
  //     // cssClass: 'alertcambiasquadra',
  //     cssClass: this.etheme.theme_selected,
  //     buttons: [{
  //       text: 'Annulla',
  //       handler: data => {
  //         // console.log('Cancel clicked');
  //       }
  //     },
  //     {
  //       text: 'SI CONFERMO',
  //       handler: data => {
  //         // console.log('Saved clicked');
  //           this.viewcontroller.dismiss(s);
  //       }
  //     }]
  //   });
  //   alert.present();
 
  // }

  // iscriviti(s) {
  //   const alert = this.alertCtrl.create({
  //     title: 'Selezione direzione',
  //     subTitle: 'Hai selezionato la direzione "' + s.nome + '", confermi questa scelta?',
  //     cssClass: 'alertdirezione',
  //     buttons: [{
  //       text: 'Annulla',
  //       handler: data => {
  //         // console.log('Cancel clicked');
  //       }
  //     },
  //     {
  //       text: 'SI CONFERMO',
  //       handler: data => {
  //         // console.log('Saved clicked');
  //         this.viewcontroller.dismiss(s);
  //       }
  //     }]
  //   });
  //   alert.present();


  // }
}



// WEBPACK FOOTER //
// ./src/pages/hr_selezionamj/hr_selezionamj.ts